/* eslint-disable func-names */
/* eslint-disable react/jsx-no-bind */
import { useState } from 'react'
import { CheckedIcon } from '../../assets/icons/Checked'
import { ClipIcon } from '../../assets/icons/clipIcon'
// import { DownloadIcon } from '../../assets/icons/download-four'
import { FileIcon } from '../../assets/icons/File'
import SheetsDownload from '../../components/SheetsDownload'
import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import TourImportarPlanilha from '../../utils/JoyRide/tourImportarPlanilha'
import {
  // ButtonDownload,
  ImportFile,
  H3,
  H4,
  PrincipalDiv,
  Span,
  Input,
  ButtonSubmit,
  File,
  FileIconStyles,
} from './SpreadSheet.style'
import { useSpreadSheet } from './useSpreadSheet'
import { SaveAnimated } from '../../components/SaveAnimated'
import Tooltips from '../../components/Tooltip'

export function SpreadSheets() {
  const { handleSetImport, importFile, isValidFile, handleUploadSheets } =
    useSpreadSheet()

  const [isLoading, setIsLoading] = useState(false)
  const handleUpload = async () => {
    setIsLoading(true)
    await handleUploadSheets(importFile!)
    setIsLoading(false)
  }

  // const handleFile = async () => {
  //   const timer = setTimeout(() => {
  //     goToPage('/empresas')
  //     const timer2 = setTimeout(() => {
  //       goToPage('/planilhas')
  //     }, 0)
  //     return () => clearTimeout(timer2)
  //   }, 0)
  //   return () => clearTimeout(timer)
  // }

  return (
    <>
      <DivTitle id="saudacaoPlanilha" color="black" size={22}>
        <ContainerTitle id="finalizacaoPlanilha">
          Importar Planilhas
          <Tooltips icon={<Tour steps={TourImportarPlanilha} />} text="Tour" />
        </ContainerTitle>
      </DivTitle>

      <PrincipalDiv>
        <H3>
          Baixe o arquivo abaixo, preencha-o devidamente e em seguida importe
          para o sistema.
        </H3>
        <Span id="download">
          Modelo de Planilha de Vendas
          <SheetsDownload
            text="Download da planilha"
            url="https://api.teste.predicao.w3erp.com.br/central/download?name=MODELO_IMPORTACAO_VENDA"
          />
          {/* <ButtonDownload to="/docs/teste.xlsx" target="_blank">
            <DownloadIcon /> Download da planilha
          </ButtonDownload> */}
        </Span>
        {/* <Span>
          Nome da planilha 2
          <ButtonDownload to="/docs/teste.xlsx" target="_blank">
            <DownloadIcon /> Download da planilha
          </ButtonDownload>
        </Span> */}
        <form>
          <H4>Anexe o arquivo preenchido</H4>
          {!isValidFile ? (
            <>
              <ImportFile id="anexar" htmlFor="files">
                <ClipIcon />
                Anexar planilha
              </ImportFile>
              <Input
                id="files"
                accept=".xlsx"
                type="file"
                name="importFile"
                onChange={handleSetImport}
              />
            </>
          ) : (
            <>
              <File htmlFor="files">
                <FileIconStyles>
                  <FileIcon /> {importFile?.name}
                </FileIconStyles>
                <CheckedIcon />
              </File>

              <Input
                id="files"
                accept=".xlsx"
                type="file"
                name="importFile"
                onChange={handleSetImport}
              />
              {/* <File type="button" onClick={handleFile}>
                <FileIconStyles>
                  <FileIcon /> {importFile?.name}
                </FileIconStyles>
                <CheckedIcon />
              </File> */}
              <ButtonSubmit
                id="processarDados"
                type="button"
                onClick={() => handleUpload()}
              >
                Processar dados
              </ButtonSubmit>
              {isLoading ? <SaveAnimated mensagem="upload" /> : ''}
            </>
          )}
        </form>
      </PrincipalDiv>
    </>
  )
}
